module.exports = __webpack_public_path__ + "static/media/daman&diu.1b345366.png";